document.querySelectorAll('.view-cursor').forEach((cursor) => {
    const container = cursor.parentElement;
    if (container) {
        container.addEventListener('mousemove', (event) => {
            const left = event.offsetX - 10;
            const top = event.offsetY - 10;
            cursor.style.transform = `translate(${left}px, ${top}px)`;
        });
    }
});
